// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XYFc","location":"Header_location__8TazU"};